// extracted by mini-css-extract-plugin
export default {"fields":"rrgQrF","time":"P5pXYv","mobile":"vtbZch"};